import { Loader2, WifiOff } from 'lucide-react';

import { EmptyState } from '@/components/common/EmptyState';
import { Button } from '@/components/ui/button';

/**
 * Shown when the platform could not find out whether this module is
 * available, rather than when it has been told the module is off.
 *
 * Every flag reads `false` until `/system/feature-flags/me` answers, so a
 * single failed request would otherwise present the whole product as
 * "not available for your tenant" and send the user to an administrator who
 * has nothing to fix.
 */

export function FeatureCheckLoadingPlaceholder() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6">
      <EmptyState
        icon={<Loader2 className="size-10 animate-spin" />}
        title="Checking access"
        description="One moment while we confirm which modules your tenant has."
      />
    </div>
  );
}

export function FeatureCheckFailedPlaceholder({
  onRetry,
}: {
  onRetry: () => void;
}) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6">
      <EmptyState
        icon={<WifiOff className="size-10" />}
        title="Couldn't check your access"
        description="We couldn't reach the server to confirm which modules are available, so this page is hidden for now. This is a connection problem, not a permission one — your administrator has nothing to change."
        action={
          <Button variant="outline" onClick={onRetry}>
            Try again
          </Button>
        }
      />
    </div>
  );
}
